export default __webpack_public_path__ + "static/media/Group 848@2x.747f07cb.png";